import forDevice from '../../../common/hoc/for-device';
import BannerDesktop from './banner-desktop';
import BannerMobile from './banner-mobile';

export default forDevice(BannerMobile, BannerDesktop);
